<template>
    <router-view />
    <ImpersonationBanner />
</template>

<style scoped>
/* Config de les capçaleres de tota la web */
:deep(.v-data-table thead th) {
    background-color: #626363 !important;
    color: white !important;
    font-weight: bold;
    transition: color 0.3s ease;
    cursor: default;
}

:deep(.v-data-table thead th:hover) {
    color: #ffffff !important;
}



</style>
<script setup lang="ts">
import ImpersonationBanner from '@/components/ImpersonationBanner.vue'
</script>
